import { Button } from "antd";
import { BsArrowRightShort } from "react-icons/bs";
import { Link } from "react-router-dom";
import "./MostLikedCategoryItem.scss";

const MostLikedCategoryItem = ({ title, sub_title, btn_link, color, image }) => {
    return (
        <div className="pe-sm-4 pb-4 most-liked-category-item">
            <div
                className="row g-0 border rounded-4 overflow-hidden shadow-sm category-card"
            >
                <div
                    className="col-6 category-info"
                    style={{ "--category-color": color }}
                >
                    <div className="d-flex flex-column gap-2 px-5 p-5 justify-content-between h-100">
                        <div className="fs-2 category-title">{title}</div>
                        <div className="d-flex flex-column gap-2">
                            <div className="category-subtitle">{sub_title}</div>
                            <Link to={btn_link}>
                                <Button type="primary" className="shop-now-btn" block>
                                    <div className="d-flex align-items-center gap-2">
                                        <span style={{ color }}>
                                            Shop Now
                                        </span>
                                        <BsArrowRightShort color={color} size={20} />
                                    </div>
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center justify-content-center p-2 h-100">
                        <img
                            src={image}
                            alt={title}
                            className="category-image"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MostLikedCategoryItem;
